import React from 'react';

import { Tooltip } from 'antd';
import { TableOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandTableView: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            <Tooltip title="Table view">
                <TableOutlined />
            </Tooltip>
        </div>
    );
}

export default CommandTableView;